import { useMemo } from "react";
import provinciasData from "../../../../assets/provincias.json";

// Transforma el JSON en estructuras con código y nombre
const buildCatalogs = () => {
  const provincias = [];
  const cantonesPorProvincia = {};
  const parroquiasPorCanton = {};

  Object.entries(provinciasData).forEach(([provCode, prov]) => {
    if (!prov || !prov.provincia) return;
    provincias.push({ code: provCode, name: prov.provincia });

    const cantones = Object.entries(prov.cantones || {}).map(([cantCode, cant]) => {
      const parroquias = Object.entries(cant?.parroquias || {}).map(([parrCode, parrName]) => ({
        code: parrCode,
        name: parrName || "",
      }));
      if (cant?.canton) {
        parroquiasPorCanton[cant.canton] = parroquias;
      }
      return { code: cantCode, name: cant?.canton || "", parroquias };
    });

    cantonesPorProvincia[prov.provincia] = cantones.filter((c) => c.name);
  });

  provincias.sort((a, b) => (a.name || "").localeCompare(b.name || "", "es", { sensitivity: "base" }));

  return { provincias, cantonesPorProvincia, parroquiasPorCanton };
};

export default function useUbicacionesEcuador() {
  const { provincias, cantonesPorProvincia, parroquiasPorCanton } = useMemo(buildCatalogs, []);

  const getCantones = (provinciaName) => cantonesPorProvincia[provinciaName] || [];
  const getParroquias = (cantonName) => parroquiasPorCanton[cantonName] || [];

  return {
    provincias, // [{code,name}]
    getCantones, // (provinciaName) => [{code,name,parroquias}]
    getParroquias, // (cantonName) => [{code,name}]
  };
}
